import formLiveScheduledEvents from './formGroupLivesScheduled/formLiveScheduledEvents';
import formLiveScheduledProviders from './formGroupLivesScheduled/formLiveScheduledProviders';


export default {
  title: 'Lives Scheduled',
  attributeName: 'livesScheduled',
  sessionParams: [],
  getURL: 'livesScheduled',
  updateURL: 'livesScheduled',
  idAttribute: 'id',
  noArea: true,
  goBack: true,
  autoUpdate: true,
  formConfig: [
    formLiveScheduledProviders,
    formLiveScheduledEvents,
  ],
};
